import palette from 'theme/palette'
import constants from 'constants/index'

import templates from '../../templates'
import components from '../../components'

import { ratio } from '../../helpers'

import { PADDING, GAP } from '../../constants'

const generalInformations = async (
  pdf,
  date,
  questionnaires,
  customStyles,
  partnerReport = false,
  supplierName = '',
) => {
  const calculateAverage = (prop) => {
    const validQuestionnaires = questionnaires.filter(
      (questionnaire) =>
        questionnaire.status !== constants.questionnaire.NOT_APPLICABLE_STATUS,
    )

    const total = validQuestionnaires.reduce(
      (acc, questionnaire) => acc + questionnaire[prop],
      0,
    )
    const average = total / validQuestionnaires.length
    return Math.round(average) + '%'
  }

  const compliance = calculateAverage('complianceGap')
  const progressPercentage = calculateAverage('answerPercentage')

  const chapterCoverDescription = () => {
    if (partnerReport) {
      return `Síntese das principais informações e métricas do fornecedor ${supplierName.toUpperCase()}`
    }
    return 'Síntese das principais informações e métricas apresentadas no painel de controle.'
  }

  templates.chapterCover({
    pdf,
    title: 'VISÃO GERAL',
    subtitle: chapterCoverDescription(),
    customStyles,
  })

  pdf.addPage('a4', 'p')
  components.lineWithDate(pdf, date)

  const subtitle = partnerReport ? supplierName.toUpperCase() : 'VISÃO GERAL'

  components.subtitle(pdf, subtitle, GAP)

  components.rectangle(
    pdf,
    PADDING,
    GAP * 1.25,
    ratio(660),
    palette.primary.main,
    ratio,
    'Progresso',
    progressPercentage,
  )

  components.rectangle(
    pdf,
    PADDING * 5,
    GAP * 1.25,
    ratio(660),
    palette.primary.main,
    ratio,
    'Conformidade',
    compliance,
  )

  const mountQuestionnaireRow = (questionnaire) => [
    [
      'Progresso de resolução do questionário',
      `${questionnaire.answerPercentage}%`,
    ],
    [
      'Conformidade do questionário',
      questionnaire.status === constants.questionnaire.NOT_APPLICABLE_STATUS
        ? 'Não se aplica.'
        : `${Math.round(questionnaire.complianceGap)}%`,
    ],
  ]

  questionnaires.forEach((questionnaire, index) => {
    let startY = index === 0 ? GAP * 3 : pdf.autoTable.previous.finalY + 16

    components.table(
      pdf,
      [[questionnaire.name || questionnaire.kind, 'Total (%)']],
      mountQuestionnaireRow(questionnaire),
      startY,
      0.5,
      PADDING,
      true,
    )
  })
}

export default generalInformations
